import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Phone, AlertTriangle } from "lucide-react";
import { BOOKMAKERS, GUIDES } from "../../lib/data";
import { NewsletterForm } from "../NewsletterForm";

export const Footer = () => {
    return (
        <footer
            className="bg-[#0A1623] border-t border-[#2A4A6B] mt-16"
            data-testid="site-footer"
        >
            <div className="container-x py-14">
                {/* Newsletter top strip */}
                <div className="card-elev p-6 sm:p-7 mb-12 grid grid-cols-1 md:grid-cols-[1.2fr_1fr] gap-6 items-center">
                    <div>
                        <h3 className="font-heading text-xl sm:text-2xl font-bold text-white tracking-tight">
                            Restez à l'affût des dernières infos
                        </h3>
                        <p className="text-sm text-gray-400 mt-2">
                            Notre sélection hebdo d'infos foot et
                            pronostics — directement dans votre boîte mail.
                        </p>
                    </div>
                    <NewsletterForm />
                </div>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
                    <div>
                        <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-wider">
                            Pronospot
                        </h4>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Accueil
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/a-propos"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    À propos de nous
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Actualités
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-wider">
                            Avis Bookmakers
                        </h4>
                        <ul className="space-y-2 text-sm">
                            {BOOKMAKERS.slice(0, 5).map((b) => (
                                <li key={b.slug}>
                                    <Link
                                        to={`/avis/${b.slug}`}
                                        className="text-gray-400 hover:text-[#00C853]"
                                    >
                                        Avis {b.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-wider">
                            Pronostics & Cotes
                        </h4>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/comparatif"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Comparatif des Bonus
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/cotes"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Cotes du Jour
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/competitions/ligue-1"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Ligue 1
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/competitions/champions-league"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Champions League
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/competitions/coupe-du-monde"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Coupe du Monde 2026
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-heading font-bold text-white mb-4 text-sm uppercase tracking-wider">
                            Ressources & Légal
                        </h4>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <Link
                                    to="/guides"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Analyses & Guides
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/nous-contacter"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Nous contacter
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/politique-editoriale"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Politique éditoriale
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/mentions-legales"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Mentions légales
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/politique-confidentialite"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Confidentialité
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/politique-cookies"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Politique des Cookies
                                </Link>
                            </li>
                            <li>
                                <button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        window.dispatchEvent(new Event("open-cookie-banner"));
                                    }}
                                    className="text-gray-400 hover:text-[#00C853] text-left bg-transparent border-0 p-0 cursor-pointer font-sans text-sm"
                                    data-testid="footer-cookie-settings"
                                >
                                    Gestion des cookies
                                </button>
                            </li>
                            <li>
                                <Link
                                    to="/jeu-responsable"
                                    className="text-gray-400 hover:text-[#00C853]"
                                >
                                    Jeu responsable
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-[#2A4A6B] flex flex-col md:flex-row md:items-center justify-between gap-6">
                    <div className="flex items-center gap-3 flex-wrap">
                        <div className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-[#1E3A5F] border border-[#2A4A6B]">
                            <ShieldCheck
                                size={16}
                                className="text-[#00C853]"
                            />
                            <span className="text-xs font-semibold text-white">
                                ANJ Agréé
                            </span>
                        </div>
                        <div className="flex items-center justify-center w-9 h-9 rounded-full bg-[#E63946] text-white text-xs font-extrabold">
                            18+
                        </div>
                        <div className="flex items-center gap-2 px-3 py-1.5 rounded-md bg-[#1E3A5F] border border-[#2A4A6B]">
                            <Phone size={14} className="text-[#00C853]" />
                            <span className="text-xs font-semibold text-white">
                                09 74 75 13 13
                            </span>
                        </div>
                    </div>
                </div>

                <div className="mt-8 text-xs text-gray-500 leading-relaxed space-y-3">
                    <div className="flex items-start gap-2">
                        <AlertTriangle
                            size={14}
                            className="text-[#FFB300] mt-0.5 flex-shrink-0"
                        />
                        <p>
                            <strong>Pronospot.com est un comparateur indépendant. Nous ne percevons aucune commission sur vos mises ou vos pertes.</strong>{" "}
                            Les paris sportifs sont strictement réservés aux
                            personnes majeures (18+). Jouer comporte des
                            risques : endettement, isolement, dépendance. Pour
                            être aidé, appelez le 09 74 75 13 13 (appel non
                            surtaxé).
                        </p>
                    </div>
                    <p className="text-gray-600">
                        © 2026 Pronospot.com — Tous droits réservés. Site indépendant à but informatif.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
